import { render, staticRenderFns } from "./FeedbackProblem.vue?vue&type=template&id=7eaa6fa1&scoped=true&"
import script from "./FeedbackProblem.vue?vue&type=script&lang=js&"
export * from "./FeedbackProblem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackProblem.vue?vue&type=style&index=0&id=7eaa6fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaa6fa1",
  null
  
)

component.options.__file = "FeedbackProblem.vue"
export default component.exports